import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import AdminSidebar from "../../components/admin/AdminSidebar";
import { CommunicationsList } from "../../components/admin/CommunicationsList";
import { RetryQueueLegacy } from "../../components/admin/RetryQueueLegacy";
import { TemplatesTab } from "../../components/admin/TemplatesTab";
import { Inbox, RotateCw, FileText } from "lucide-react";

const TABS = [
  { key: "feed", label: "Feed", icon: Inbox, helper: "Outbound emails & SMS + inbound customer replies" },
  { key: "retry", label: "Failed / Retry", icon: RotateCw, helper: "Failed emails awaiting retry or dismissal" },
  { key: "templates", label: "Templates", icon: FileText, helper: "Email & SMS templates used by manual sends and fan-out" },
];

export default function AdminCommunications() {
  const [params, setParams] = useSearchParams();
  // Read the active tab from ?tab=… so /admin/email-queue → ?tab=retry redirect
  // lands on the right tab without an extra hop.
  const initial = TABS.some(t => t.key === params.get("tab")) ? params.get("tab") : "feed";
  const [tab, setTab] = useState(initial);

  useEffect(() => {
    const next = TABS.some(t => t.key === params.get("tab")) ? params.get("tab") : "feed";
    if (next !== tab) setTab(next);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const switchTab = (next) => {
    setTab(next);
    const nextParams = new URLSearchParams(params);
    if (next === "feed") nextParams.delete("tab"); else nextParams.set("tab", next);
    setParams(nextParams, { replace: true });
  };

  const active = TABS.find(t => t.key === tab) || TABS[0];

  return (
    <div className="min-h-screen bg-[#FAF8F0]">
      <AdminSidebar />
      <main className="lg:ml-64 p-6 md:p-10" data-testid="admin-communications-page">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-2xl font-semibold text-[#282828] mb-1" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Communications</h1>
          <p className="text-[12px] text-[#676664]/70 mb-5">{active.helper}</p>

          <div className="flex gap-1 mb-6 border-b border-[#282828]/10 flex-wrap" data-testid="comms-hub-tabs">
            {TABS.map(t => {
              const Icon = t.icon;
              return (
                <button
                  key={t.key}
                  onClick={() => switchTab(t.key)}
                  className={`flex items-center gap-2 px-4 py-2 text-[12px] tracking-wider uppercase border-b-2 transition-colors ${
                    tab === t.key ? "border-[#9A7B4F] text-[#282828]" : "border-transparent text-[#676664]/60 hover:text-[#282828]"
                  }`}
                  data-testid={`comms-hub-tab-${t.key}`}
                >
                  <Icon className="w-3.5 h-3.5" /> {t.label}
                </button>
              );
            })}
          </div>

          {tab === "feed" && <CommunicationsList />}
          {tab === "retry" && <RetryQueueLegacy />}
          {tab === "templates" && <TemplatesTab />}
        </div>
      </main>
    </div>
  );
}
